
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/[...slug]",
      function () {
        return require("private-next-pages/hotels/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotels/[...slug]"])
      });
    }
  